import { UserContext } from '@web-stories-wp/story-editor';
import { useContext } from 'react';

const useUser = () => useContext(UserContext);

export default useUser;
